<template>
    <v-row>
        <v-dialog v-model="showDialog" persistent max-width="350px">
            <v-form ref="form">
                <v-card>
                    <v-card-text style="padding: 20px;">
                        <v-container>
                            <v-row cols="12" justify="center">
                                <v-icon style="font-size: 50px;">mdi-cellphone-cog</v-icon>
                            </v-row>
                            <v-row cols="12" justify="center" style="margin-top: 15px;">
                                <span style="font-size: 12px; text-align: center;">{{ text }}</span>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <a @click.stop="openUrl()" style="margin-left: 20px; font-size: 0.875rem;">
													{{ $t('upgrade-app.goto-google-play') }}
												</a>
                        <v-spacer></v-spacer>
                        <v-btn color="#c01033" text class="btn-link" style="width: 100px;" @click="showDialog=false">
													{{ $t('app.buttons.close') }}
												</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </v-row>
</template>

<script>
import cordova from "../../../api/cordova";

export default {
    name: 'UpgradeAppDialog',
    data() {
        return {
						text: null,
            showDialog: false,
        }
    },
    methods: {
        isVisible: function() {
            return this.showDialog;
        },
        open: function(text) {
						this.text = text;
            this.showDialog = true;
        },
        close: function() {
            this.showDialog = false;
        },
				openUrl() {
					cordova.openUrl(encodeURI('https://play.google.com/store/apps/details?id=com.wemob.wedrive'));
          this.showDialog = false;
				}
    },
  }
</script>